import { render, staticRenderFns } from "./AdvantageCard.vue?vue&type=template&id=58f42e1c&scoped=true"
import script from "./AdvantageCard.vue?vue&type=script&lang=js"
export * from "./AdvantageCard.vue?vue&type=script&lang=js"
import style0 from "./AdvantageCard.vue?vue&type=style&index=0&id=58f42e1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58f42e1c",
  null
  
)

export default component.exports